export default __webpack_public_path__ + "static/pro@2x-036bd9ef8ee84f72b23d28bf5f3f595d.webp";